import { render, staticRenderFns } from "./BookingVehicle.vue?vue&type=template&id=25f4d8dc&scoped=true"
import script from "./BookingVehicle.vue?vue&type=script&lang=js"
export * from "./BookingVehicle.vue?vue&type=script&lang=js"
import style0 from "./BookingVehicle.vue?vue&type=style&index=0&id=25f4d8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4d8dc",
  null
  
)

export default component.exports